export const groupStatus = Object.freeze({
    INACTIVE: 1,
    ACTIVE: 2,
    FINISHED: 3
});

export const playerStatusCodes = Object.freeze({
    ACTIVE: 1,
    CUT: 2,
    WD: 3,
    RTD: 4,
    DQ: 5,
    DNS: 6
});

export const nextOutAvailablityRounds = ['1', '2', '3', '4'];

export const noFavoriteMessage = {
    title: 'Favourite players',
    body: 'You don’t have any favourites added yet, click on the star button to add them.'
};
